import ITTIModel from '@/ittijs/ITTIModel';
export default class extends ITTIModel {
  constructor() {
    super('Services');
  }
}